var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { slugify } from "healthex-common/utils";
export class HealthSystemBaseViewModel {
    constructor(container) {
        this.authManager = container.authManager;
        this.healthSystemUIManager = container.healthSystemUIManager;
        this.appUIManager = container.appUIManager;
        this.routingUIManager = container.routingUIManager;
    }
    get isLive() {
        return this.healthSystemUIManager.isLive;
    }
    get isHealthSystem() {
        return this.healthSystemUIManager.isHealthSystem;
    }
    get isITAdmin() {
        return this.healthSystemUIManager.isITAdmin;
    }
    get isResearchAdmin() {
        return this.healthSystemUIManager.isResearchAdmin;
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get orgId() {
        return this.authManager.orgId;
    }
    get isReadOnlyMode() {
        return this.healthSystemUIManager.isITAdmin && !this.healthSystemUIManager.isResearchAdmin;
    }
    goToHomePage() {
        this.appUIManager.navigateToPage("HEALTHCARE_ORG_ANALYTICS");
    }
    goToResearchPage(tab) {
        this.routingUIManager.redirectTo(NamedRoutes.PROJECTS, {
            tab: slugify(tab),
        });
    }
    goToStudyDetailsPage(studyId) {
        this.routingUIManager.redirectTo(NamedRoutes.PROJECTS_OTHER_DETAILS, {
            studyId,
        });
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "isLive", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "isHealthSystem", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "isITAdmin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "isResearchAdmin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "orgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "orgId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HealthSystemBaseViewModel.prototype, "isReadOnlyMode", null);
